import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-privacy-policy',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss',
})
export class PrivacyPolicyComponent implements OnInit {
  private gtm = inject(GtmService);
  private seo = inject(SeoService);
  platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/privacy',
        page_title: 'Privacy Policy | Horizinns'
      });
    }
    this.seo.updateMetaTags(
      'Privacy Policy',
      'Privacy Policy for Horizinns',
      undefined,
      `${environment.appUrl}/privacy`);
  }
}
